import { type IntlShape } from 'react-intl';
import { decodeHtml } from '../helpers/html-entities';
import { UserType } from '../common/enums';

const RESTRICTED_ACCESS_TYPES = new Set<UserType>([
  UserType.NO_ACCESS,
  UserType.BANNED,
  UserType.ACCESS_REQUESTED,
  UserType.ACCESS_DECLINED
]);

export const isUserAccessRestricted = (userType?: UserType): boolean =>
  userType !== undefined && RESTRICTED_ACCESS_TYPES.has(userType);

export const formatUserName = (userName: string | undefined, accessRestricted = false, intl: IntlShape): string => {
  const name = userName ? decodeHtml(userName) : '';
  return accessRestricted ? `${name} ${intl.formatMessage({ id: 'inactive', defaultMessage: '(Inactive)' })}` : name;
};
